import React from 'react';
export const FooterSection = () => {
  return <footer className="bg-familia-bg border-t border-familia-section py-10 md:py-16 px-4 md:px-6" data-id="element-89">
      <div className="max-w-7xl mx-auto w-[92%] md:w-full" data-id="element-90">
        <div className="flex flex-col items-center text-center mb-8 md:mb-12" data-id="element-91">
          <div className="flex flex-col mb-4" data-id="element-92">
            <span className="text-familia-cyan font-display text-2xl sm:text-3xl font-bold leading-tight" data-id="element-93">
              📚 ENGLISH EN FAMILIA™
            </span>
            <span className="text-familia-gray text-xs sm:text-sm font-semibold tracking-widest uppercase mt-1" data-id="element-94">
              Mega Pack Bilingüe Cambridge
            </span>
          </div>

          <div className="flex flex-wrap justify-center gap-x-8 gap-y-4 text-sm text-familia-gray mt-8" data-id="element-95">
            <a href="mailto:soporte@englishenfamilia.com" className="hover:text-familia-cyan transition-colors" data-id="element-96">
              📧 soporte@englishenfamilia.com
            </a>
            <a href="#" className="hover:text-familia-cyan transition-colors" data-id="element-97">
              📲 @englishenfamilia
            </a>
            <a href="#" className="hover:text-familia-cyan transition-colors" data-id="element-98">
              🌐 www.englishenfamilia.com
            </a>
          </div>
        </div>

        <div className="w-full h-px bg-familia-cyan/15 mb-12" data-id="element-99" />

        <div className="max-w-4xl mx-auto space-y-6 text-center text-[10px] sm:text-xs text-familia-gray leading-relaxed" data-id="element-100">
          <p data-id="element-101">
            © ENGLISH EN FAMILIA™ 2025 — Todos los derechos reservados.
            Prohibida la reproducción sin autorización expresa.
          </p>
          <p data-id="element-102">
            ENGLISH EN FAMILIA™ es un producto digital de contenido educativo
            para familias argentinas cuyos hijos preparan exámenes Cambridge. No
            está afiliado a Cambridge University Press. Los resultados dependen
            del compromiso y dedicación de cada familia.
          </p>
        </div>
      </div>
    </footer>;
};